module.exports = __webpack_public_path__ + "img/kontenery.4c88e71d.svg";